import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

/**
 * Wraps children with a reveal-on-scroll animation.
 * animation: 'fade-up' | 'fade-in' | 'scale-in'
 */
function ScrollReveal({ children, animation = 'fade-up', delay = 0, threshold = 0.15, className = '', style = {} }) {
    const [ref, isVisible] = useScrollReveal({ threshold, delay });
    return (
        <div
            ref={ref}
            className={`scroll-reveal scroll-${animation} ${isVisible ? 'scroll-visible' : ''} ${className}`}
            style={style}
        >
            {children}
        </div>
    );
}

export default ScrollReveal;
